import decode from 'jwt-decode';
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_CHECK, AUTH_GET_PERMISSIONS } from 'react-admin';

export const isAdmin = role => role === 'admin';
export const isApp = role => role === 'application';
export const isUser = role => role === 'user';

export const JWT_TOKEN = 'u-token';

export const read = () => decode(get());
export const get = () => localStorage.getItem(JWT_TOKEN);
export const set = val => localStorage.setItem(JWT_TOKEN, val);
export const del = () => localStorage.removeItem(JWT_TOKEN);

export const authProvider = (type, params) => {
  if (type === AUTH_LOGIN) {
    set(params.token);
  }

  if (type === AUTH_LOGOUT) {
    del(JWT_TOKEN)
  }

  if (type === AUTH_CHECK) {
    try {
      let token = read();

      if (token && token.exp > Math.floor(Date.now() / 1000)) {
        return Promise.resolve();
      } else {
        return Promise.reject();
      }
    } catch (err) {
      return Promise.reject();
    }

  }

  if (type === AUTH_GET_PERMISSIONS) {
    try {
      const token = read();

      if (token.role && token.exp > Math.floor(Date.now() / 1000)) {
        return Promise.resolve(token.role);
      } else {
        return Promise.reject();
      }
    } catch (err) {
      return Promise.reject();
    }
  }

  return Promise.resolve();
};


// WEBPACK FOOTER //
// ./resources/assets/js/authProvider.js